// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import AuditStatusTcsm from '@deere/cps-it.warranty-model-factory/lib/audit-status-tcsm';
import LabeledString from '../../../../shared/components/labeled-string';
import {buildNumber} from '../../../../shared/services/build-number';
import {getClassName} from '../../services/get-class-name';

const ReportListItem = props =>
    <section className='report-list-item'>
        <div className='item-header'>
            {props.item.tcsmName}
        </div>
        <div className='row'>
            <div className='overdue'>
                <LabeledString
                    data={buildNumber(props.item.overdue)}
                    label='OVERDUE'
                />
                <span className={getClassName('dot-icon-red', props.item.overdue)}/>
            </div>
            <div className='due'>
                <LabeledString
                    data={buildNumber(props.item.due3Months)}
                    label='DUE_WITHIN_3_MONTHS'
                />
                <span className={getClassName('dot-icon-yellow', props.item.due3Months)}/>
            </div>
            <LabeledString
                className='completed'
                data={buildNumber(props.item.compl24Months)}
                label='COMPLETED_IN_LAST_24_MONTHS'
            />
        </div>
    </section>;

ReportListItem.displayName = 'ReportListItem';
ReportListItem.propTypes = {
    item: PropTypes.instanceOf(AuditStatusTcsm).isRequired
};

export default ReportListItem;



// WEBPACK FOOTER //
// ./src/reports/audit-status/components/report-list/report-list-item.js